import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import User from "../../entities/User";

import UserProducts from "./common/UserProducts.jsx";
import UserContact from "./common/UserContact.jsx";
import UserValidationErrorsSummaryText from "./common/UserValidationErrorsSummaryText.jsx";
import { isLiteralKeyFromEvent } from "../../utilities/EventsHelper";
import classNames from "classnames";
import RedTextInput from "./common/RedTextInput";
import ValidationHelper from "../../utilities/ValidationHelper";
import Actions from "../../actions/PersonnelActions";


export class CreateUserInfo extends Component {
    constructor (props) {
        super(props);

        this.state = {
            emailIsValid: true,
            phoneIsValid: true,
            lastNameIsValid: true,
            firstNameIsValid: true,

        };

        this.onChangeLastName = this.onChangeLastName.bind(this);
        this.onChangeFirstName = this.onChangeFirstName.bind(this);
        this.setUserContactNumber = this.setUserContactNumber.bind(this);
        this.setUserEmail = this.setUserEmail.bind(this);
        this._handlePhoneNumberOnFocus = this._handlePhoneNumberOnFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this._handleFirstNameOnFocus = this._handleFirstNameOnFocus.bind(this);
        this._handleLastNameOnFocus = this._handleLastNameOnFocus.bind(this);
        this._handlePhoneNumberOnFocus = this._handlePhoneNumberOnFocus.bind(this);
        this._handleEmailOnFocus = this._handleEmailOnFocus.bind(this);
        this.onProductClick = this.onProductClick.bind(this);
        this.onSelectRole = this.onSelectRole.bind(this);
    }

    onChangeLastName (e) {
        const value = e.target.value;
        this.props.setLastName(value);
    }

    onChangeFirstName (e) {
        const value = e.target.value;
        this.props.setFirstName(value);
    }

    setUserContactNumber (e) {
        const value = e.target.value;
        this.props.setPhone(value);
    }

    setUserEmail(e) {
        const value = e.target.value;
        this.props.setEmail(value);
    }

    _handleNameKeyPress (e) {
        if (!isLiteralKeyFromEvent(e)) {
            e.preventDefault();
        }
    }

    onBlur () {
        const user = this.props.user;
        const state = this.state;
        if (ValidationHelper.isNullOrEmpty(user.firstName)) {
            state.firstNameIsValid = false;
        }

        if (ValidationHelper.isNullOrEmpty(user.lastName)) {
            state.lastNameIsValid = false;
        }

        if (!ValidationHelper.isNullOrEmpty(user.email)) {
            state.emailIsValid = ValidationHelper.isValidEmailFormat(this.props.user.email);
        }

        if (!ValidationHelper.isNullOrEmpty(user.phone)) {
            state.phoneIsValid = ValidationHelper.isValidPhoneNumber(this.props.user.phone);
        }

        this.setState(state);
    }

    _handleFirstNameOnFocus () {
        this.setState({ firstNameIsValid: true });
        this.props.hideErrorSummary();
    }

    _handleLastNameOnFocus () {
        this.setState({ lastNameIsValid: true });
        this.props.hideErrorSummary();
    }

    _handlePhoneNumberOnFocus () {
        this.setState({ phoneIsValid: true });
        this.props.hideErrorSummary();
    }

    _handleEmailOnFocus() {
        this.setState({ emailIsValid: true });
        this.props.hideErrorSummary();
    }

    onProductClick (checked, productId) {
        this.props.selectProduct(checked, productId);
    }

    onSelectRole (productId, roleId, roleName) {
        this.props.selectRole(productId, roleId, roleName);
    }

    render () {
        const errorResult = this.props.validationResult;
        const classErrorsSummary = classNames("alert", "alert-danger", { "hidden": !errorResult.show });
        const user = this.props.user;

        return (
            <div id="UserSettings" className="col-md-12">
                <div className={classErrorsSummary}
                    id="errorsSummary">
                    <UserValidationErrorsSummaryText validationObject={this.props.validationResult}/>
                </div>
                <div id="UserInfo" className="col-md-12 control-row">
                    <div className="col-md-5">
                        <div className="formControlTitle">First Name</div>
                        <RedTextInput id="firstName"
                            onChange={this.onChangeFirstName}
                            onKeyPress={this._handleNameKeyPress}
                            onBlur={this.onBlur}
                            onFocus={this._handleFirstNameOnFocus}
                            value={this.props.user.firstName}
                            hasError={!this.state.firstNameIsValid}
                        />
                    </div>
                    <div className="col-md-5">
                        <div className="formControlTitle">Last Name</div>
                        <RedTextInput id="lastName"
                            onChange={this.onChangeLastName}
                            onKeyPress={this._handleNameKeyPress}
                            onBlur={this.onBlur}
                            onFocus={this._handleLastNameOnFocus}
                            value={this.props.user.lastName}
                            hasError={!this.state.lastNameIsValid}
                        />

                    </div>
                    <div className="col-md-2">
                        <div className="formControlTitle">Site Id</div>
                        <span className="picker-hollow"
                            id="siteId">
                            {this.props.organization.site}</span>
                    </div>
                </div>

                <UserContact user={user} onEmailChange = {this.setUserEmail}
                    setUserContactNumber = {this.setUserContactNumber}
                    onBlur = {this.onBlur}
                    _handlePhoneNumberOnFocus = { this._handlePhoneNumberOnFocus }
                    _handleEmailOnFocus = {this._handleEmailOnFocus}
                    emailIsValid = {this.state.emailIsValid}
                    phoneIsValid = {this.state.phoneIsValid}
                />

                <UserProducts organizationProducts={this.props.productRoles}
                    userProducts={this.props.user.userProducts}
                    selectProduct = {this.onProductClick}
                    selectRole = {this.onSelectRole}
                />

                <div className="col-md-12">
                    <span>Click "Create New User" to save and generate the password</span>
                </div>
            </div>
        );
    }
}

CreateUserInfo.defaultProps = {

};

CreateUserInfo.propTypes = {
    user: PropTypes.instanceOf(User),
    products: PropTypes.any,
    onTextChange: PropTypes.func,
    hideErrorSummary: PropTypes.func
};

const mapStateToProps = state => ({
    products: state.personnelState.products,
    organization: state.organizationState.organization,
    productRoles: state.personnelState.productRoles,
    user: state.personnelState.user
});

const mapDispatchToProps = (dispatch) => {
    return ({
        setFirstName: (value) => dispatch(Actions.setField("firstName", value)),
        setLastName: (value) => dispatch(Actions.setField("lastName", value)),
        setEmail: (value) => dispatch(Actions.setField("email", value)),
        setPhone: (value) => dispatch(Actions.setField("phone", value)),
        saveUser: (user) => dispatch(Actions.saveUser(user)),
        selectProduct: (checked, productId) => dispatch(Actions.selectProduct(checked, productId)),
        selectRole: (productId, roleId, roleName) => dispatch(Actions.selectRole(productId, roleId, roleName)),
    });
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateUserInfo);

